import * as z from "zod";
import { BOT_DESCRIPTION_MAX_LENGTH, BOT_NAME_MAX_LENGTH } from "./domain.js";
import { Id } from "./ids.js";

/** A saved template's id, or `builtin:<department>` for one from the team builder. */
export const BotTemplateIdSchema = z.string().trim().min(1).max(80);

/** What "Start from" lists. A template carries a bot's job and settings, never what it holds. */
export const BotTemplateSchema = z.object({
  id: BotTemplateIdSchema,
  name: z.string(),
  title: z.string(),
  description: z.string().max(BOT_DESCRIPTION_MAX_LENGTH),
  builtin: z.boolean(),
  /** The member who saved it, or a Space admin, may remove it. */
  canRemove: z.boolean(),
});
export type BotTemplate = z.infer<typeof BotTemplateSchema>;

export const SaveBotTemplateInput = z.object({
  botId: Id,
  name: z.string().trim().min(1).max(BOT_NAME_MAX_LENGTH).optional(),
});

/** A Space holds at most this many saved templates. */
export const BOT_TEMPLATES_MAX = 100;
